import { render, staticRenderFns } from "./CreateCandidate.vue?vue&type=template&id=6064c2dc&"
import script from "./CreateCandidate.vue?vue&type=script&lang=js&"
export * from "./CreateCandidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports